export default __webpack_public_path__ + "static/media/review20.2e0f248d.jpg";